import { secureAssetUrl } from "./secureUrl";

function secureSpans(spans) {
  if (!spans) return;
  for (const span of spans) {
    if (span.href) span.href = secureAssetUrl(span.href);
  }
}

function secureBlocks(blocks) {
  if (!blocks) return;
  for (const node of blocks) {
    if (node.url) node.url = secureAssetUrl(node.url);
    secureSpans(node.spans);
    secureSpans(node.caption);
    for (const row of node.rows || []) {
      for (const cell of row) secureSpans(cell);
    }
    for (const col of node.columns || []) secureBlocks(col);
    secureBlocks(node.children);
  }
}

/** Upgrade http:// URLs in page JSON (defense in depth vs mixed content). */
export function sanitizePage(page) {
  if (!page) return page;
  secureBlocks(page.blocks);
  return page;
}
